import { Button, Flex, Spin, Typography } from 'antd';
import React from 'react';

type PagedSelectPopupFooterProps = {
  loadingMore: boolean;
  loadMoreError: boolean;
  onRetry: () => void;
};

const PagedSelectPopupFooter: React.FC<PagedSelectPopupFooterProps> = ({
  loadingMore,
  loadMoreError,
  onRetry,
}) => {
  if (!loadingMore && !loadMoreError) return null;

  return (
    <div
      style={{
        borderTop: '1px solid rgba(5, 5, 5, 0.06)',
        padding: '8px 12px',
      }}
    >
      {loadingMore ? (
        <Flex align="center" justify="center" gap={8} role="status">
          <Spin size="small" />
          <Typography.Text type="secondary">正在加载更多</Typography.Text>
        </Flex>
      ) : (
        <Flex justify="center">
          <Button type="link" size="small" onClick={onRetry}>
            加载失败，重试
          </Button>
        </Flex>
      )}
    </div>
  );
};

export default PagedSelectPopupFooter;
